export function filteredTours (state) {
  return state.tours.filter(tour => {
    switch (state.tourFilter) {
      case 1:
        return tour.experience_basetype === 1
      case 2:
        return tour.experience_basetype === 2
      case 3:
        return tour.experience_basetype === 2 && tour.experience_class === 0
      case 4:
        return tour.experience_basetype === 2 && tour.experience_class === 1
      default:
        return true
    }
  })
}
